import axios from 'axios'
import moment from 'moment'
import emojiStrip from 'emoji-strip'

let BACKEND_URL = 'https://contents.geek9.kr'
let POCKETBASE_URL = 'http://34.64.121.6'
const SMART_STORE_URL = 'https://smartstore.naver.com/geek9/products/'
const CAFE_STORE_URL = 'https://cafe.naver.com/geek9/'

let WSRV_POCKETBASE_URL = '//wsrv.nl/?url=http://34.64.121.6:8090/api/files/'
let REDIRECT_URI = 'https://geek9.kr'

let axiosGeek9
if(window.location.hostname === 'localhost') {
  BACKEND_URL = 'http://localhost'
  REDIRECT_URI = BACKEND_URL + ':3000'
  BACKEND_URL = BACKEND_URL + ':4000'
  axiosGeek9 = axios.create({
    baseURL: BACKEND_URL
  })
} else {
  axiosGeek9 = axios.create({
    baseURL: BACKEND_URL
  })
}

let FORWARDER = new Map()

const CAFE_MENU_LIST = 
  [
    {name:"여성패션", id:"100"},
    {name:"남성패션", id:"101"},
    {name:"유니폼", id:"102"},
    {name:"장난감", id:"103"},
    {name:"신발", id:"104"},
    {name:"등산", id:"106"},
    {name:"주얼리", id:"107"},
    {name:"기타", id:"105"}
  ]

const getCateNameById = (id) => {
  const item = CAFE_MENU_LIST.find(menu => menu.id === id);
  return item ? item.name : null;
}

// const AWS = require('aws-sdk')
require('dotenv').config()
let request = require('request')

// AWS.config.region = 'ap-northeast-2'
// AWS.config.credentials = new AWS.CognitoIdentityCredentials({
//     IdentityPoolId: 'ap-northeast-2:53a1ff0b-4f33-4181-b416-a62e5d1a507d',
// })

// const s3 = new AWS.S3({
//   accessKeyId: process.env.S3_ACCESS_KEY_ID,
//   secretAccessKey: process.env.S3_SECRET_ACCESS_KEY, 
//   region: process.env.S3_REGION
// })

const getOAuthToken = async (code, state) => {
  try {
    const tokenResponse = await axios.post(
      "https://nid.naver.com/oauth2.0/token",
      null,
      {
        params: {
          grant_type: "authorization_code",
          client_id: process.env.VUE_APP_NAVER_CLIENT_ID,
          client_secret: process.env.VUE_APP_NAVER_SECRET_KEY,
          code: code,
          state: state
        }
      }
    )
    return tokenResponse.data.access_token
  } catch (error) {
    console.error("OAuth 토큰 발급 실패:", error.response?.data || error.message)
    throw error
  }
}

const stripHtmlTags = (html) => {
  return html.replace(/<[^>]*>/g, '')
}

const copyClipboard = (val) => {
  navigator.clipboard.writeText(val)
  .then( () => console.log('복사되었습니다 - ' + val)
  ).catch( (err) => console.log(err) )
}

const list2String = async (list) => {
  let result = ''
  for(let i=0; i<list.length; i++) {
    result += JSON.stringify(list[i])
    if(i !== list.length-1) result += ', '
  }
  return result
}

const resizeImage = (image, width) => {
  
  return new Promise( (resolve, reject) => {
    image.onload = async  function() {
      try {
        const originalWidth = image.width
        const originalHeight = image.height
        
        const aspectRatio = originalWidth / originalHeight
        
        const newWidth = width
        const newHeight = width / aspectRatio
        
        let canvas = document.createElement('canvas')
        let context = canvas.getContext('2d')
        
        canvas.width = newWidth
        canvas.height = newHeight
        
        context.drawImage(image, 0, 0, newWidth, newHeight)
        resolve(canvas.toDataURL('image/jpeg')) 
      } catch (err) {
        reject(err)
      }
    }
  })
}

const getGoogleTranslateUrl = (param) => {
  const country = param.country
  const desc = param.desc
  let sl = ''
  if(country === '프랑스') sl = 'fr'
  else if(country === '스페인') sl = 'es'
  else if(country === '이탈리아') sl = 'it'
  else if(country === '홍콩') sl = 'zh'
  else if(country === '네덜란드') sl = 'nl'
  return "https://translate.google.com/?sl=" + sl + "&tl=ko&text=" + desc
}

const requestFacebook = () => {
  return new Promise((resolve, reject) => {
    if (window.FB) {
      resolve({sdkReady:true})
      return
    }

    window.fbAsyncInit = function() {
      window.FB.init({
        appId : process.env.VUE_APP_FACEBOOK_APP_ID,
        xfbml : true,
        version : 'v21.0'
      })
      window.FB.AppEvents.logPageView()
      resolve({sdkReady:true})
    };

    (function(d, s, id){
      var js, fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) {return;}
      js = d.createElement(s); js.id = id
      js.src = "https://connect.facebook.net/en_US/sdk.js"
      fjs.parentNode.insertBefore(js, fjs);
      js.onerror = () => reject({sdkReady:false})
    }(document, 'script', 'facebook-jssdk'))
  })
}

const requestGoogle = async (param) =>{
  return new Promise( (resolve, reject) => {
    const code = param.code
    axios.post(
      'https://oauth2.googleapis.com/token',
      {
        code: code,
        client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
        client_secret: process.env.VUE_APP_GOOGLE_CLIENT_SECRET,
        // redirect_uri: 'http://localhost:3000/login/oauth2/code/google',
        redirect_uri: REDIRECT_URI,
        grant_type: 'authorization_code',
      },
    ).then( async (res) => {
      const accessToken = res.data.access_token
      if(accessToken) {
        await axios.get(
          'https://www.googleapis.com/oauth2/v3/userinfo',
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          },
        ).then( async (res2) => {
          resolve(res2)
        })
      } else reject(undefined)
    })
    .catch( (err) => {
      console.log(err)
      reject(err)
    })
  })
}

const translate = (source, target, query) => {
  const options = {
    url: 'https://api-free.deepl.com/v2/translate',
    form: {'target_lang':target, 'text':query},
    headers: {'Authorization':process.env.DEEPL_KEY}
    // url: 'https://openapi.naver.com/v1/papago/n2mt',
    // form: {'source':source, 'target':target, 'text':query},
    // headers: {'X-Naver-Client-Id':process.env.PAPAGO_CLIENT_ID, 'X-Naver-Client-Secret': process.env.PAPAGO_CLIENT_SECRET, 'Content-Type':'application/json'}
  }

  return new Promise( (resolve, reject) => {
    request.post(options, function (error, response, body) {
      if (!error && response.statusCode == 200) {
        resolve(body)
      } else {
        reject('error = ' + response.statusCode)
        console.log('error = ' + response.statusCode)
      }
    }) 
  })
}

// window.location.hostname === 'localhost' ? 
// axios.defaults.baseURL = 'http://localhost:4000' : 
// axios.defaults.baseURL = GCP_URL :            // GCP 
// axios.defaults.baseURL = HR4U_PC_URL + ':4000' :     // HR4U

// axios.defaults.baseURL = 'https://graphql.geek9.kr'
// axios.defaults.baseURL = GCP_URL

const getCookies = (key) => {
  return window.$cookies.get(key)
}

const setCookies = (key, value) => {
  window.$cookies.set(key, value)
}

const setPage = (page) => {
  setCookies('page', page)
}

const clear_cache = () => {
  window.$cookies.clear()
}

const validate = (type, target) => {
  let value
  if(type === 'phone') {
    value =  target.value
    value = value.replace(/[^0-9]/g, '')
    target.value = value
  } else if(type === 'email') {
    value =  target.value
    let reg = /^[0-9a-zA-Z-_.]*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/
    if (reg.test(value) === false || value === '') {
      alert('이메일을 정확하게 입력해주시기 바랍니다.\n대행 진행상황을 이메일로도 보내드리고 있습니다.')
    }
  } else if(type === 'space') {
    value =  target.value
    value = value.replace(/ /g, '')
    target.value = value
  }
}

const getDateByFormat = (date, format) => {
  return moment(date).format(format)
}

const getDate = (date, format) => {
  return moment.unix(date).format(format)
}

const getIsoDates = (month) => {
  const now = new Date()
  const koreaTimezoneOffset = '+09:00'

  now.setUTCHours(0, 0, 0, 0)
  
  function substractDate(date, month) {
    const newDate = new Date(date)
    newDate.setUTCMonth(date.getUTCMonth() - month)
    return newDate
  }

  function toISO8601(date) {
    return date.toISOString().replace(/\.\d{3}Z$/, koreaTimezoneOffset)
  }

  if(month === 0) return toISO8601(now, month)
  else return toISO8601(substractDate(now, month))
 }

const getDateRange = (param) => {
  const startDate = param.startDate
  const endDate = param.endDate
  const range = moment(endDate).diff(moment(startDate), 'days')
  const dateRange = []
  for(let i = 0; i <= range; i++) {
    dateRange.push(moment(startDate).add(i, 'days').format(param.format))
  }
  return dateRange
}

const getRange = (param) => {
  var endDate = moment(new Date()).format('YYYYMMDD')
  var startDate
  if(param === 'r1') startDate = moment(new Date()).add(-29, 'days').format('YYYYMMDD')
  else if(param === 'r2') startDate = moment(new Date()).add(-89, 'days').format('YYYYMMDD')
  else if(param === 'r3') startDate = moment(new Date()).add(-179, 'days').format('YYYYMMDD')
  else if(param === 'r4') startDate = moment(new Date()).add(-364, 'days').format('YYYYMMDD')
  else startDate = moment(new Date()).add(param, 'days').format('YYYYMMDD')
  return {startDate: startDate, endDate: endDate}
}

const getUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 3 | 8)
    return v.toString(16)
  })
}

// const uploadPb = async (file, service, type) => {
//   return new Promise( (resolve, reject) => {
//       const formData = new FormData()
//       formData.append("file", file)
//       formData.append('service', service)
//       formData.append('type', type)
//       pb.collection('upload').create(formData)
//       .then(res => {
//         console.log(res)
//           const collectionId = res.collectionId 
//           const id = res.id
//           const fileName = res.file
//           // const imgUrl = pbUrl + '/api/files/' + collectionId + '/' + id + '/' + fileName 
//           // resolve(imgUrl)
//           resolve(collectionId + '/' + id + '/' + fileName)
//       })
//       .catch(err => {
//           reject("Upload failed");
//           console.error("Error:", err)
//       })
//       .finally(() => {
//           console.log(service + ' - ' + type)
//       })
//   })
// }

const deleteS3 = async (key, s3) => {
  if(key.length > 5) {
    const file = 'geek9/qna/' + key
    const params = {
      Bucket: "business-upload",
      Key: file,
    }
    try {
     s3.deleteObject(params, function(err, data) {
        if (err) {
          console.log('Error deleting file: ', err)
        } else {
          console.log('File deleted : ' + data)
        }
      })
    } catch (error) {
      console.error(error)
    }
  }
}
const contentTypeList = [
  { name: 'logistics'},
  { name: 'blog'},
  { name: 'review'},
  { name: 'market'},
  { name: 'hot'},
  { name: 'mail'},
]
const downloadS3 = async (key) => {
  const file = 'geek9/qna/' + key
  const params = {
    Bucket: "business-upload",
    Key: file,
  }
  try {
    const data = await this.s3.getObject(params).promise()
    const blob = new Blob([data.Body], { type: "image/jpeg" })
    const reader = new FileReader()
    reader.onload = () => {
      console.log(reader.result)
    }
    reader.readAsDataURL(blob)
  } catch (error) {
    console.error(error)
  }
}
const getCountryFlag = (country) => {
  if(country === '프랑스') return 'https://geek9.kr/assets/france.png'
  else if(country === '홍콩') return 'https://geek9.kr/assets/hongkong.png'
  else if(country === '스페인') return 'https://geek9.kr/assets/spain.png'
  else if(country === '이탈리아') return 'https://geek9.kr/assets/italy.png'
  else if(country === '네덜란드') return 'https://geek9.kr/assets/netherlands.png'
  else if(country === '싱가포르') return 'https://geek9.kr/assets/singapore.png'
  else if(country === '영국') return 'https://geek9.kr/assets/uk.png'
  else if(country === '독일') return 'https://geek9.kr/assets/ger.png'
  else if(country === '일본') return 'https://geek9.kr/assets/jpn.png'
  else if(country === '중국') return 'https://geek9.kr/assets/chn.png'
  else if(country === '미국') return 'https://geek9.kr/assets/usa.png'
  else if(country === '캐나다') return 'https://geek9.kr/assets/can.png'
  else if(country === '호주') return 'https://geek9.kr/assets/australia.png'
  else if(country === '오스트리아') return 'https://geek9.kr/assets/austria.png'
  else if(country === '뉴질랜드') return 'https://geek9.kr/assets/nz.png'
  else if(country === '베트남') return 'https://geek9.kr/assets/vietnam.png'
  else if(country === '대만') return 'https://geek9.kr/assets/taiwan.png'
  else if(country === '벨기에') return 'https://geek9.kr/assets/bel.png'
  else if(country === '말레이시아') return 'https://geek9.kr/assets/myr.png'
  // else if(country === '태국') return 'https://geek9.kr/assets/thailand.png'
  else return 'https://geek9.kr/assets/question.png'
}
const getFirstImageSrc = (html) => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(html, 'text/html')
  const firstImg = doc.querySelector('img')
  return firstImg ? firstImg.src : null
}
const getAllImageSrcs = (html) => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(html, 'text/html')
  const imgElements = doc.querySelectorAll('img')
  return Array.from(imgElements).map(img => img.src)
}
const uploadS3 = async (file, fileName, s3) => {
  var params = {}
  params.Bucket = 'business-upload'
  params.Key =  'geek9/qna/'+ fileName
  params.Body = file

  await s3.putObject(params, async (err) => {
    if(err)  console.log(err,err.stack)
  })
}

const textCut = (text, length) => {
  const maxLength = length
  if(text.length > maxLength) return text.substring(0, maxLength) + '...'
  else return text
}

const getCurrency = (country) => {
  let currency = ' EUR'
  if(country === '홍콩') currency = ' HKD'
  else if(country === '영국') currency = ' 파운드'
  else if(country === '미국') currency = ' USD'
  else if(country === '일본') currency = ' 엔'
  else if(country === '중국') currency = ' 위안화'
  else if(country === '싱가포르') currency = ' SGD'
  else if(country ==='호주') currency = ' AUD'
  else if(country ==='뉴질랜드') currency = ' NZD'
  else if(country ==='베트남') currency = ' VND'
  else if(country ==='캐나다') currency = ' CAD'
  else if(country ==='대만') currency = ' TWD'
  else if(country ==='말레이시아') currency = ' MYR'
  else if(country === '기타') currency = ''

  return currency
}

const axiosGql = async (type, variables) => {
  if(type === 'GET_ACCOUNT' || type === 'SELECT_COIN_JOBS' || type === 'SELECT_COIN_ORDER' || type === 'GET_CLOSED_ORDERS' || type === 'GET_ALL_MARKETS' || type === 'SELECT_ALL_MODELS' ) 
    return axiosGeek9({method: 'get', url: '/coin', params: variables})
  else if(type === 'DELETE_COIN_JOBS' || type === 'UPDATE_COIN_JOBS' || type === 'cancelCoin' || type === 'restartCoin' || type === 'INSERT_COIN_JOBS' ) 
    return axiosGeek9({method: 'post', url: '/coin', params: variables})
  else if(type === 'SELECT_IPORTER_ORDER_DTL' || type === 'SELECT_ORDER_CHART' || type === 'SELECT_NAVER_PROFILE' || type === 'SELECT_NAVER_TOKEN' || type ==='WEEK_KEYWORD' || type ==='MONTH_KEYWORD' || type ==='YEAR_KEYWORD' || type === 'store' || type === 'SELECT_GEEKTS' || type === 'SELECT_STORE_UPLOAD_BY_URL' || type === 'SELECT_STORE_UPLOAD_BY_KEYWORD' || type === 'SELECT_STORE_UPLOAD' || type === 'SELECT_STORE_CATE' || type === 'SELECT_ORDER_PRICE_DTL' || type === 'googleSheet' || type === 'SELECT_KEYWORDS' || type=== 'SELECT_BOARD' || type=== 'SELECT_BOARD_BY_KEYWORD' || type=== 'SELECT_BOARD_SUGGEST' || type=== 'SELECT_BOARD_BY_IDX' || type === 'SELECT_ORDER_IMG_URL' || type === 'SELECT_DATASET_QA' || type === 'READ_MODEL' || type === 'READ_FILE_ALL' || type === 'READ_FILE_BY_PAGE' || type === 'SELECT_ORDER_REGIST' ||  type === 'SELECT_POLICY_GRP' || type === 'vinted' || type === 'currency' || type === 'merciTotebag-detail' || type === 'merciTotebag' || type === 'SELECT_TODO' || type === 'SELECT_TRADE_BY_ID' || type === 'SELECT_WORK_MGR' || type === 'SELECT_WORK_REQUEST_HISTORY' || type === 'SELECT_WORK_WAREHOUSE' || type === 'SELECT_WORK_REQUEST' || type === 'SELECT_WORK_ESTIMATE' || type === 'SELECT_TRADE_MSG' || type === 'SELECT_TRADE' || type === 'SELECT_TRADE_BY_IDX' || type === 'SELECT_MORPHEME' || type === 'SELECT_STOPWORD' || type === 'SELECT_USERWORD' || type === 'SELECT_SENTENCE' || type === 'SELECT_DELIVERY_INFO' || type === 'SELECT_ORDER_INFO_BY_UID' || type === 'SELECT_ORDER_INFO_BY_CONDITION' || type === 'SELECT_ORDER_INFO_LIST' || type === 'SELECT_DISTINCT_ORDER_LIST2' || type === 'SELECT_DISTINCT_ORDER_LIST' || type === 'SELECT_ETF_LIST' || type === 'SELECT_STOCK_TRADE2' || type === 'SELECT_STOCK_TRADE' || type ==='SELECT_RECENT_SELL_STOCK' || type === 'SELECT_ALL_STOCK_PROFIT' || type === 'SELECT_STOCK_BY_DATE' || type === 'SELECT_TOP_STOCK_BY_CODE' || type === 'SELECT_STOCK_BY_CODE' || type === 'SELECT_STOCK_BY_CONDITION' || type === 'SELECT_POSSESS_LIST' || type === 'SELECT_STOCK_LIST' || type === 'SELECT_MYPAGE' || type === 'SELECT_FORWARDER' || type === 'SELECT_QNA_LIST' || type === 'SELECT_QA' || type === 'SELECT_ORDER_LIST2' || type === 'SELECT_ORDER_BY_FORWARDER' || type === 'SELECT_ORDER_STATUS_CNT2' || type === 'SELECT_WORK_REQUEST_STATUS_CNT' || type === 'SELECT_WORK_REQUEST_STATUS' || type === 'SELECT_ORDER_STATUS_CNT' || type === 'SELECT_ORDER_LIKE' || type === 'SELECT_ORDER_CART' || type === 'ADDRESS' || type === 'translate' || type === 'CAROUSELL_BY_KEYWORD' || type === 'VINTED_BY_KEYWORD' || type === 'TEMU_BY_KEYWORD' || type === 'SELECT_MOD_ORDER_HISTORY' || type === 'SELECT_SOLAIR_ORDER' || type === 'GET_CRSF' || type === 'GET_ADDR_ZIP' || type === 'SELECT_CONSUMER' || type === 'SELECT_ORDER_BY_CONDITION' || type === 'SELECT_ORDER_BY_ID2' || type === 'SELECT_TRADE_QUESTION'|| type === 'SELECT_ORDER_STATISTIC' || type === 'SELECT_ORDER_HISTORY' || type === 'SELECT_UID_BY_NAME' || type === 'SELECT_COMPANY_ORDER' || type === 'SELECT_ITEM' || type === 'SELECT_COMPANY' || type === 'SELECT_SAMSUNG_ONLY' || type === 'SELECT_USER' || type === 'SELECT_USER_BY_TYPE' || type === 'SELECT_GAME' || type === 'SELECT_NOTICE' || type === 'SELECT_NOTICE2' || type === 'SELECT_NOTICE4' || type === 'SELECT_POINT_HISTORY' || type === 'YAHOO_SELECT_STOCK_BY_CODE' || type === 'calcBuy' || type === 'calcCorpDelivery' || type === 'calcDelivery' || type === 'VINTED' || type === 'CAROUSELL' || type === 'MERCI' || type === 'SHOPEE' || type === 'presPrice' || type === 'refresh' || type === 'news' || type === 'SELECT_COMMON_USER' || type === 'dau' || type === 'wau' || type === 'mau' || type === 'recentMau' || type === 'recentWau') 
    return axiosGeek9({method: 'get', url: '/geek9', params: variables})
  else if(type === 'IPORTER_API_TRACKING_URL' || type === 'INSERT_FORWARDER' || type === 'INSERT_CAFE_PRODUCT' || type === "INSERT_CAFE_REVIEW" || type === 'UPDATE_GEEKTS_STATUS' || type === 'UPDATE_GEEKTS_BY_LIST' || type === 'DELETE_GEEKTS_BY_LIST' || type === 'instagram' || type === 'DELETE_BOARD' || type === 'DELETE_DATASET_QA' || type === 'UPDATE_DATASET_QA' || type === 'INSERT_DATASET_QA' || type === 'EXECUTE_MODEL' || type === 'UPDATE_WORK_REQUEST_FILE_NAME' || type === 'DELETE_TODO' || type === 'DELETE_COMMON_USER' || type === 'INSERT_COMMON_USER' || type === 'UPDATE_WORK_REQUEST_STATUS' || type === 'UPDATE_WORK_MGR_STATUS' || type === 'removeImg' || type === 'DELETE_TRADE' || type === 'UPDATE_TRADE_MSG' || type === 'UPDATE_TRADE' || type === 'DELETE_TRADE_CHILD_MSG' || type === 'DELETE_TRADE_MSG' || type === 'INSERT_TRADE_MSG' || type === 'UPDATE_ORDER_MSG_CHK_YN' || type === 'UPDATE_ORDER_FILE' || type === 'DELETE_QNA' || type === 'INSERT_ORDER_INFO' || type === 'UPSERT_MYPAGE' ||  type === 'UPDATE_STOCK_TRADE' || type === 'UPDATE_POSSESS' || type === 'INSERT_USER' || type === 'INSERT_ORDER_HISTORY' || type === 'UPDATE_ORDER_BY_UID' || type === 'UPDATE_ORDER_INFO_USE_YN' || type === 'UPDATE_ORDER_USE_YN' || type === 'DELETE_STOCK_TRADE' || type === 'DELETE_ORDER_INFO_BY_UID' || type === 'DELETE_ORDER_BY_UID' || type === 'DELETE_NOTICE' || type === 'DELETE_NOTICE_BY_ID' ||  type === 'DELETE_STOCK' || type === 'INSERT_STOCK_POSSESS' || type === 'INSERT_STOCK' || type === 'INSERT_STOCK_TRADE' || type === 'INSERT_STOPWORD' || type === 'INSERT_USERWORD' || type === 'INSERT_SENTENCE' || type === 'lottoNum' || type === 'geek9.updateQna' || type === 'geek9.updateQa' || type === 'INSERT_STAT_KEYWORD' || type === 'DELETE_ORDER_CART' || type === 'DELETE_ORDER_LIKE' || type === 'INSERT_ORDER_CART' || type === 'INSERT_ORDER_LIKE' || type === 'DELETE_CHECKED_ORDER' || type === 'UPDATE_ORDER_INFO_USER' || type === 'UPDATE_ORDER_ITEM' || type === 'INSERT_QNA' || type === 'UPDATE_ITEM_STOCK' || type === 'UPDATE_ORDER_ESTIMATE' || type === 'INSERT_ITEM' || type === 'INSERT_COMPANY' || type === 'UPSERT_USER' || type === 'UPDATE_NOTICE' || type === 'INSERT_NOTICE' || type === 'UPDATE_ORDER_BY_FORWARDER' || type === 'UPDATE_ORDER_BY_IDX' || type === 'INSERT_POINT_HISTORY' || type === 'SLACK' || type === 'EXECUTE_FORCE' || type === 'UPDATE_POINT' || type === 'UPSERT_MODEL' || type === 'UPSERT_ORDER_PRICE_DTL' || type === 'DELETE_ORDER_PRICE_DTL' || type === 'INSERT_ORDER_PRICE_DTL') 
    return axiosGeek9({method: 'post', url: '/geek9', params: variables})
  else if(type === 'DELETE_IMG' || type === 'DELETE_QUOTE' || type === 'UPLOAD_ORDER_FILE' || type === 'UPLOAD_IMG' || type === 'UPLOAD_MARKET_IMGS' || type === ' ' ) 
    return axiosGeek9({method: 'post', url: '/formdata/upload', data: variables, headers: { "Content-Type": "multipart/form-data" }})
  else if(type === 'SELECT_CONSULT_HR_MGR') 
    return axiosGeek9({method: 'get', url: '/consult', params: variables})
  else if(type === 'UPSERT_CONTENTS_TMP' || type === 'REMOVE_FILE_CONTENT' || type === 'INSERT_TRADE' || type === 'MODIFY_FILE_CONTENT' || type === 'WRITE_FILE' || type === 'CHATBOT_ASK' || type === 'CHATBOT_HEALTH' || type === 'CHATBOT_RESTART' || type === 'CRUZGPT_ASK' || type === 'UPDATE_MODEL' || type === 'INSERT_BOARD' || type === 'UPDATE_BOARD' || type === 'UPDATE_TODO' || type === 'INSERT_TODO' || type === 'INSERT_WORK_REQUEST_HISTORY' || type === 'DELETE_WORK_REQUEST' || type === 'DELETE_WORK_MGR' || type === 'DELETE_WORK_WAREHOUSE' || type === 'UPDATE_WORK_REQUEST' || type === 'UPDATE_WORK_WAREHOUSE' || type === 'UPDATE_WORK_MGR' || type === 'INSERT_ORDER_LIST' || type === 'INSERT_GEEKTS_LIST' || type === 'INSERT_WORK_REQUEST' || type === 'INSERT_WORK_MGR' || type === 'INSERT_WORK_ESTIMATE' || type === 'sendId')
    return axiosGeek9({method: 'post', url: '/formdata', data: variables, headers: { "Content-Type": "multipart/form-data" }})
  else if(type === 'market') 
    return axiosGeek9({method: 'get', url: '/img', params: variables})
  else if(type === 'SSR_CONTENT')
    return axiosGeek9({method: 'get', url: '/contents', params: variables})
  const res = await axios.post('/graphql', {
    headers :  {   
      'Cache-Control': ['no-cache', 'no-store', 'must-revalidate'],
      'Pragma': ['no-cache', 'no-store', 'must-revalidate'],
      'Expires': '0',
      'X-Requested-With': 'XMLHttpRequest',
    },
    withCredentials: true, query: type , variables: variables
  })
  return res.data.data
}

const calcNextPrice = async (stock, insertPrice) => {
  let nextBuyRate = 0.2
  let nextSellRate = 0.00
  let nextSellPrice
  let nextBuyPrice
  let broker = stock.BROKER
  let price = stock.PRICE

  if(insertPrice !== -1) price = insertPrice

  if(broker === '한국투자증권') {
    nextSellRate = 0.02
    nextSellPrice = price * (1 + nextSellRate)
    nextBuyPrice  = price * (1 - nextBuyRate)
  } else {
    nextSellRate = 0.25
    if(price >= 500000) {
      nextSellPrice = price + 50000.0
      nextBuyPrice  = price - 50000.0 
    } else if(price >= 100000) {
      nextSellPrice = price + 20000.0
      nextBuyPrice  = price - 20000.0 
    } else if(price >= 50000) {
      nextSellPrice = price + 10000.0
      nextBuyPrice  = price - 10000.0 
    } else if(price >= 10000) {
      nextSellPrice = price + 4000.0
      nextBuyPrice  = price - 4000.0
    } else if(price >= 1000 && price <=3000 ) {
      nextSellPrice = price + 1000.0
      nextBuyPrice  = price - 1000.0
    } else {
      nextSellPrice = price * (1 + nextSellRate)
      nextBuyPrice  = price * (1 - nextBuyRate)
      if(nextBuyPrice < 1000) nextBuyPrice = 500.0
      if(nextSellPrice < 1000) nextSellPrice = 2000.0    
    }
  }

  nextSellPrice = Math.round(nextSellPrice)
  nextBuyPrice = Math.round(nextBuyPrice)

  stock.NEXT_SELL_PRICE = nextSellPrice
  stock.NEXT_BUY_PRICE = nextBuyPrice

  return stock
}

const getRequestStatus = (param) => {
  if(param === -2) return '고객거절'
  else if(param === -1) return '취소'
  else if(param === 0) return '견적요청받음(고객->GEEK9)'
  else if(param === 1) return '견적요청했음(GEEK9->담당자)'
  else if(param === 2) return '견적받음(담당자->GEEK9)'
  else if(param === 3) return '견적제안완료(GEEK9->고객)'
  else if(param === 4) return '고객답변대기중'
  else if(param === 5) return '고객답변받음(고객->GEEK9)'
  else if(param === 6) return '거래성사'
  else if(param === 7) return '거래완료'
}

const getOrderStatus = (param) => {
  if(param === -2) return '환불완료'
  else if(param === -1) return '거래취소'
  else if(param === 0) return '주문접수'
  else if(param === 1) return '입금대기'
  else if(param === 2) return '입금완료'
  else if(param === 3) return '구매완료'
  else if(param === 4) return '입고대기'
  else if(param === 5) return '창고도착'
  else if(param === 6) return '배송중'
  else if(param === 7) return '거래완료'
  else if(param === 99) return '제외'
  else if(param === 100) return '미예약'
  else if(param === 101) return '예약'
  else if(param === 102) return '게시'
  else if(param === '환불완료') return -2 
  else if(param === '거래취소') return -1
  else if(param === '주문접수') return 0 
  else if(param === '입금대기') return 1
  else if(param === '입금완료') return 2
  else if(param === '구매완료') return 3
  else if(param === '입고대기') return 4
  else if(param === '창고도착') return 5
  else if(param === '배송중')   return 6
  else if(param === '거래완료') return 7
  else if(param === '제외') return 99
  else if(param === '미예약') return 100
  else if(param === '예약') return 101
  else if(param === '게시') return 102
  else return ''
}

const DELVERY_KR_COMPANY = [
  { name: 'Qxpress'},
  { name: '우체국EMS'},
  { name: 'DHL'},
  { name: 'FEDEX'},
  { name: 'UPS'},
  { name: 'Singpost'},
  { name: 'SF Express'},
  { name: 'HK POST'},
  { name: 'Singpost'}
]

const getDeliveryUrl = (invoiceNumber, deliveryKrCompany) => {
  if(deliveryKrCompany === "CJ대한통운") return "https://track.shiptrack.co.kr/cjkorex/" + invoiceNumber
  if(deliveryKrCompany === "SF Express") return "https://www.sf-international.com/kr/ko/dynamic_function/waybill/#search/bill-number/" + invoiceNumber
  else if(deliveryKrCompany === "우체국") return "https://track.shiptrack.co.kr/epost/" + invoiceNumber
  else if(deliveryKrCompany === "우체국EMS") return "https://track.shiptrack.co.kr/ems/" + invoiceNumber
  else if(deliveryKrCompany === "Qxpress") return "https://smartship.qxpress.net/Customer/PopupTraceParcels?TrackingNo=" + invoiceNumber
  else if(deliveryKrCompany === "롯데택배") return "https://track.shiptrack.co.kr/lotteglogis/" + invoiceNumber
  else if(deliveryKrCompany === "HK POST") return "https://webapp.hongkongpost.hk/en/mail_tracking/index.html"
  else if(deliveryKrCompany === "한진택배") return "https://track.shiptrack.co.kr/hanjin/" + invoiceNumber
  else if(deliveryKrCompany === "로젠택배") return "https://track.shiptrack.co.kr/ilogen/" + invoiceNumber
  else if(deliveryKrCompany === "KG옐로우캡택배") return "http://www.yellowcap.co.kr/custom/inquiry_result.asp?invoice_no=" + invoiceNumber
  else if(deliveryKrCompany === "현대택배")return "http://www.hanjin.co.kr/Delivery_html/inquiry/result_waybill.jsp?wbl_num=" + invoiceNumber
  else if(deliveryKrCompany === "DHL") return "http://www.dhl.co.kr/publish/kr/ko/eshipping/track.high.html?pageToInclude=RESULTS&type=fasttrack&AWB=" + invoiceNumber
  else if(deliveryKrCompany === "FEDEX") return "https://track.shiptrack.co.kr/fedexkr/" + invoiceNumber
  else if(deliveryKrCompany === "동부익스프레스") return "http://www.dongbuexpress.co.kr/Html/Delivery/DeliveryCheckView.jsp?item_no=" + invoiceNumber
  else if(deliveryKrCompany === "KGB택배") return "http://www.kgbls.co.kr/sub5/trace.asp?f_slipno=" + invoiceNumber
  else if(deliveryKrCompany === "대신택배") return "https://track.shiptrack.co.kr/ds3211/1234" + invoiceNumber
  else if(deliveryKrCompany === "UPS") return "http://www.ups.com/WebTracking/track?loc=ko_KR&InquiryNumber1=" + invoiceNumber
  else if(deliveryKrCompany === "경동택배") return "https://track.shiptrack.co.kr/kdexp/1234" + invoiceNumber
  else if(deliveryKrCompany === "천일택배") return "https://track.shiptrack.co.kr/chunil/" + invoiceNumber
  else if(deliveryKrCompany === "이노지스택배") return "http://www.innogis.net/trace02.asp?invoice=" + invoiceNumber
  else if(deliveryKrCompany === "일양로지스택배") return "https://track.shiptrack.co.kr/ilyanglogis/" + invoiceNumber
  else if(deliveryKrCompany === "CVSnet편의점택배") return "http://was.cvsnet.co.kr/src/ctod_status.jsp?invoice_no=" + invoiceNumber
  else if(deliveryKrCompany === "한덱스") return "http://btob.sedex.co.kr/work/app/tm/tmtr01/tmtr01_s4.jsp?IC_INV_NO=" + invoiceNumber
  else if(deliveryKrCompany === "하나로택배") return "http://www.hanarologis.com/branch/chase/listbody.html?a_gb=center&a_cd=4&a_item=0&fr_slipno=" + invoiceNumber
  else if(deliveryKrCompany === "TNT") return "http://www.tnt.com/webtracker/tracking.do?respCountry=kr&respLang=ko&searchType=CON&cons=" + invoiceNumber
  else if(deliveryKrCompany === "GTX") return "http://www.gtx2010.co.kr/del_inquiry_result.html?s_gbn=1&awblno=" + invoiceNumber
  else if(deliveryKrCompany === "건영택배") return "https://track.shiptrack.co.kr/kunyoung/" + invoiceNumber
  else if(deliveryKrCompany === "HB한방택배") return "http://www.hbtb.co.kr/search/s_search.asp?f_slipno=" + invoiceNumber
  else if(deliveryKrCompany === "Singpost") return "https://www.singpost.com/track-items?trackingid=" + invoiceNumber
  else return ''
}

const emojiRemover = (text) => {
  return emojiStrip(text).replace(/[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{1FAB0}-\u{1FABF}\u{2B50}]/gu, '')
}

const getOs = () => {
  const userAgent = window.navigator.userAgent
  const platform = window.navigator.platform
  const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
  const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE']
  // const iosPlatforms = ['iPhone', 'iPad', 'iPod']
  let os = ''
  if (macosPlatforms.indexOf(platform) !== -1)        os = 'Mac'
  else if ('iPhone'.indexOf(platform) !== -1)         os = 'iPhone'
  else if ('iPad'.indexOf(platform) !== -1)           os = 'iPad'
  else if ('iPod'.indexOf(platform) !== -1)           os = 'iPod'
  else if (windowsPlatforms.indexOf(platform) !== -1) os = 'Windows'
  else if (/Android/.test(userAgent))                 os = 'Android'
  else if (!os && /Linux/.test(platform))             os = 'Linux'
  return os
}

const shortenUrl = (url) => {
  return url = url.split('?')[0]
}

export default {
  getUUID, deleteS3, downloadS3, uploadS3, getOs, getDateRange, getIsoDates,getDateByFormat, axiosGql, setCookies, getCookies, setPage, getRange, getDeliveryUrl, DELVERY_KR_COMPANY, getOrderStatus, getRequestStatus, emojiRemover, validate, getDate, clear_cache, calcNextPrice, BACKEND_URL, POCKETBASE_URL, WSRV_POCKETBASE_URL, SMART_STORE_URL, CAFE_STORE_URL, translate, textCut, getCurrency, getFirstImageSrc, getAllImageSrcs, getGoogleTranslateUrl, shortenUrl, copyClipboard, stripHtmlTags, getOAuthToken, CAFE_MENU_LIST, FORWARDER, getCateNameById, list2String, getCountryFlag, contentTypeList, resizeImage, requestGoogle, requestFacebook
}